import { CondimentInterface } from "../entities/Condiment";

export const getTotalPartsOfCondiments = (condiments: CondimentInterface[]) =>
  condiments.reduce((acc: number, item) => acc + item.meta.parts, 0);

export const getTotalGramsOfCondiments = (condiments: CondimentInterface[]) =>
  condiments.reduce((acc: number, item) => acc + item.meta.grams, 0);

export const getTotalPercentageOfCondiments = (
  condiments: CondimentInterface[],
) => condiments.reduce((acc: number, item) => acc + item.meta.percentage, 0);
